// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__14l9O","additionalInfo":"AgreementModal_additionalInfo__2STsR"};